import { DecoratorNode, NodeKey, SerializedLexicalNode, Spread } from "lexical";
import { ConnectionComponent } from "./ConnectionComponent";

export interface ConnectionPayload {
  platform: string;
  type: string;
  identifier: string;
  title: string;
}

export type SerializedConnectionNode = Spread<
  {
    connection: ConnectionPayload;
    version: 1;
  },
  SerializedLexicalNode
>;

export class ConnectionNode extends DecoratorNode<React.ReactNode> {
  __connection: ConnectionPayload;

  static getType(): string {
    return "connection";
  }

  static clone(node: ConnectionNode): ConnectionNode {
    return new ConnectionNode(node.__connection, node.__key);
  }

  static importJSON(serializedNode: SerializedConnectionNode): ConnectionNode {
    return $createConnectionNode(serializedNode.connection);
  }

  constructor(connection: ConnectionPayload, key?: NodeKey) {
    super(key);
    this.__connection = connection;
  }

  createDOM(): HTMLElement {
    const div = document.createElement("span");
    div.className = "connection-node";
    return div;
  }

  updateDOM(): false {
    return false;
  }

  getConnection(): ConnectionPayload {
    const self = this.getLatest();
    return self.__connection;
  }

  getTextContent() {
    const connection = this.getLatest().__connection;
    return `{connection:${connection.platform}:${connection.type}:${connection.identifier}:${connection.title}}`;
  }

  exportJSON(): SerializedConnectionNode {
    return {
      type: this.getType(),
      connection: this.getConnection(),
      version: 1,
    };
  }

  decorate(): React.ReactNode {
    return <ConnectionComponent connection={this.__connection} />;
  }
}

export function $createConnectionNode(
  connection: ConnectionPayload,
): ConnectionNode {
  return new ConnectionNode(connection);
}

export function $isConnectionNode(node: any): node is ConnectionNode {
  return node instanceof ConnectionNode;
}
